'use client';

import datadog from '@/logging/datadog';
import { heap } from '@/logging/heap';
import sentry from '@/logging/sentry';
import setupAxeCore from '@/utility/axeCoreTool';
import smartlook from '@/logging/smartlook';

datadog();
heap();
sentry();
setupAxeCore();
smartlook();

export default function Home() {
  return <div>Hello world!</div>;
}
